import { API_BASE_URL } from "@/api/api.config";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";

const useGetHiddenContent = (queryParams) => {
  const queryString = new URLSearchParams(queryParams).toString();

  const requestUrl = `${API_BASE_URL}/api/v3/content-hide/?${queryString}`;

  return useLazyRestQuery(requestUrl);
};

export default useGetHiddenContent;
